<div *ngIf="isLoading">Loading Account Group List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="accountGroup"
        [(ngModel)]="model.accountGroup" [required]="required">
  <option *ngFor="let singleAccountGroup of accountGroups" [ngValue]="singleAccountGroup">{{ singleAccountGroup.name
    }}
  </option>
</select>
